import * as Artemis from './index';

if (typeof window === 'object') {
	window.Artemis = Artemis;
}